import $ from 'jquery';

$(() => {

	if ($('.header').length === 0) return;

	parseIcons();

	$('.m-header-bar__menu-icon').on('click', toggleMobileMenu);

	$('.header .menu-item-has-children > a').on('click', toggleMobileSubMenu);
	
	$('.header .menu > .menu-item-has-children').on('mouseenter', showDesktopSubMenu);
	$('.header .menu > .menu-item:not(.menu-item-has-children)').on('mouseenter', hideDesktopSubMenu);
	$('.header .sub-menu').on('mouseleave', hideDesktopSubMenu);

});

const toggleMobileMenu = () => {
	$('body').toggleClass('mobile-menu-open');
}

const toggleMobileSubMenu = event => {
	if (window.innerWidth >= 1260) return;

	event.preventDefault();

	const $this = $(event.target);

	$this
		.parent()
		.toggleClass('open');
	
	$this
		.siblings('.sub-menu')
		.slideToggle();
}

const showDesktopSubMenu = (event) => {
	if (window.innerWidth < 1260) return;

	const $this = $(event.currentTarget);

	$this.addClass('open');
}

const hideDesktopSubMenu = (event) => {
	if (window.innerWidth < 1260) return;

	$('.header .menu-item').removeClass('open');
}

const parseIcons = () => {
	if (typeof menu_icons === 'undefined') return;

	const icons = JSON.parse(menu_icons);

	icons.forEach(icon => {
		if (!icon) return;

		const [url, pageId] = icon;

		$(`.header .sub-menu .page-id-${pageId} a`).prepend(`<img src="${url}">`);
	})
}